import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  options: {customProperties: true},
  theme: {
    themes: {
      dark: {
        accent: '#fccb17',
        primary: '#0066CC',
      },
      light: {
        accent: '#d7aa02',
        primary: '#0066CC',
      },
    },
  },
});
